const config = {
  apiUrl:
    process.env.REACT_APP_API_URL ||
    'https://us-central1-yogamatt-404214.cloudfunctions.net/api/api',

  // apiUrl: 'http://192.168.1.91:5000/api',
  returnUrl: 'https://yogamatt.info/return',
  websiteUrl: 'https://www.yogamatt.org',
  redirectUrlClass:
    (process.env.REACT_APP_API_URL ||
      'https://us-central1-yogamatt-404214.cloudfunctions.net/api/api') +
    '/classes/share-card?to=',
  redirectUrlMembership:
    (process.env.REACT_APP_API_URL ||
      'https://us-central1-yogamatt-404214.cloudfunctions.net/api/api') +
    '/classes/share-card?to=',
  adminLoginEndpoint: '/admin/login',
  adminProvidersEndpoint: '/admin/providers',
  adminClassesEndpoint: '/admin/classes',
  adminClassesScrapeEndpoint: '/admin/classes/scrape-url',
  adminClassesScrapeContentEndpoint: '/admin/classes/scrape-content',
  /** Provider-auth scrape (same scraper as admin). */
  classesScrapeEndpoint: '/classes/scrape-url',
  adminPasswordResetRequestEndpoint: '/admin/password-reset/request',
  adminPasswordResetVerifyEndpoint: '/admin/password-reset/verify',
  // Same Web OAuth client as the provider Expo app. Add http://localhost:3000
  // and https://app.yogamatt.org under Authorized JavaScript origins in Google Cloud.
  googleWebClientId:
    process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID ||
    '263818300186-2pot00rbm72rghhs9no8h92l7dk22iih.apps.googleusercontent.com',
  appleClientId: process.env.REACT_APP_APPLE_CLIENT_ID || '',
  // Redirect is always the current origin + /enter-app. Register each host in Apple Developer.
};

export default config;